import { render, staticRenderFns } from "./POSStoreProducts.vue?vue&type=template&id=ac8066a8&scoped=true"
import script from "./POSStoreProducts.vue?vue&type=script&lang=ts"
export * from "./POSStoreProducts.vue?vue&type=script&lang=ts"
import style0 from "./POSStoreProducts.vue?vue&type=style&index=0&id=ac8066a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8066a8",
  null
  
)

export default component.exports